<template>
    <div style="border: 0px solid black; width:100%;">
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-primary" style="width:100%">
          <!-- Search container -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">{{ $t("search.title") }}</h3>
            </div>
            <div class="box-body">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-search"></i>
                    </div>
                    <input
                      v-on:keyup.enter="onSearchEmail(1)"
                      type="text"
                      class="form-control"
                      :placeholder="$t('common.info')"
                      v-model="search.sentInfo"
                    />
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <div class="input-group date">
                    <div class="input-group-addon">
                      <i class="fa fa-calendar"></i>
                    </div>
                    <date-picker
                      v-model="search.sentDate"
                      :config="options"
                    />
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom: 0px;">
                <div style="margin-right: 15px">
                  <button
                    type="button"
                    class="btn btn-labeled btn-success pull-right"
                    @click="onSearchEmail(1)"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-search"></i>
                    </span>
                    {{ $t("search.search_button") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="box-body">
            <lte-table
              ref="lte_table"
              :hdBackground="hdBackground"
              :data="gridEmailDataList"
              :columns="gridColumns"
              search_filter="left-search"
              :useFilter="useFilter"
              :row_mouse_pointer="false"
              :boxStyle="boxStyle"
              :customColumns="customColumns"
            ></lte-table>
            <div class="box-footer clearfix" style="display:contents;">
              <paginator :item="paginatorItem" @onpaginate="onPagination" />
            </div>
          </div>
        </div>
      </row>
    </div>
     <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import LTETable from "@/components/LTETable.vue";
import Paginator from "@/components/Paginator.vue";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
// import moment from "moment"
import utils from '@/lib/utils'
import constants from "@/lib/constantsData";

export default {
  name: "MailHistoryAgent",
  data() {
    return {
      paginatorItem: {
          commit_function: "GET_LIST_EMAIL_HISTORY_AGENT"
      },
      boxStyle: false,
      useFilter: false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true },
        { text: "email_history_agent.date", isHidden: true },
        { text: "email_history_agent.subject", isHidden: true },
        // { text: "email_history_agent.content", isHidden: true },
        { text: "email_history_agent.from", isHidden: true },
        // { text: "email_history_agent.schedule", isHidden: true },
        { text: "email_history_agent.bcc", isHidden: true },
        { text: "email_history_agent.cc", isHidden: true },
        { text: "email_history_agent.to", isHidden: true },
        { text: "email_history_agent.status", isHidden: true },
      ],
      customColumns: {
        "email_history_agent.content": "none",
      },
      search: {
        sentInfo: null,
        sentDate: null
      },
      hdBackground: "background-color: #4b646f;color:white;border:1px solid white;",
      gridEmailDataList: [],
      isLoading: false,
      selected: null,
      options: {
        format: "DD-MM-YYYY"
      },
    };
  },
  watch: {
    GET_LANG: function() {
      // this.onSearchEmail(1)
    },
    GET_LIST_EMAIL_HISTORY_AGENT_DATA: function() {
      this.gridEmailDataList = [];
      this.GET_LIST_EMAIL_HISTORY_AGENT_DATA.forEach((email, i) => {
        let attach_files = email.attach_files;
        if (attach_files != null)
        {
          attach_files = attach_files.substring(attach_files.lastIndexOf('/') + 1, attach_files.length);
          attach_files = attach_files.replace("']", "")
        }

        let data = {
          id: email.id,
          attach_files: attach_files,
          "common.nonumber": i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size,
          "email_history_agent.date": utils.formatSqlDate(email.date_created, null, constants.dateOptions.format_date_time),
          "email_history_agent.subject":  email.subject,
          // "email_history_agent.content": email.content,
          "email_history_agent.from": email.sender,
          // "email_history_agent.schedule": email.schedule,
          "email_history_agent.bcc": email.bcc,
          "email_history_agent.cc": email.cc,
          "email_history_agent.to": email.to,
          "email_history_agent.status": email.description,
        };
        this.gridEmailDataList.push(data);
      });
      this.isLoading = false;
    },
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA",
      "GET_LIST_EMAIL_HISTORY_AGENT_DATA",
      "GET_LANG"
    ])
  },
  methods: {
    onPagination: function(data) {
        this.onSearchEmail(data.params.page)
    },
    onSearchEmail(page) {
        const data = {
          params: {
            page: page,
            sentDate: this.search.sentDate,
            sentInfo: this.search.sentInfo,
          }
        }
        this.isLoading = true
        this.GET_LIST_EMAIL_HISTORY_AGENT(data).then(
            function(){
                this.isLoading = false
            }.bind(this)
        )
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_LIST_EMAIL_HISTORY_AGENT",
    ]),
  },
  mounted() {
    const payload = {
      params: {
        page: 1
      }
    }
    this.isLoading=true
    this.GET_LIST_EMAIL_HISTORY_AGENT(payload).then(
      function(){}
    ).catch(
      function(){
        this.ON_SHOW_TOAST({
          message: this.$t("customization_table.err_missing_info"),
          styleType: "danger"
        });
        setTimeout(() => { this.isLoading=false; }, 3000);
      }.bind(this)
    )
  },
  components: {
    loading: Loading,
    "lte-table": LTETable,
    "paginator": Paginator,
    "lte-core-alert": LTECoreAlert,
    "date-picker": datePicker
  }
};
</script>

<style>
.page-item.disabled .page-link{
    display: none;
}
.detail-email {
  display: flex;
  flex-direction: row;
}
.row-email.button {
  text-align: center;
  border-top: 2px solid;
}
.left-email-content {
    width: 10%;
}
.right-email-content {
    width: 90%;
}
.row-email, .content-email {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Mailbox/ManagementMailHistoryAgent.vue